import { useRef, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export function VigImportRemove() {
  const file = useRef(null);
  const [op, setOp] = useState("");
  const [busy, setBusy] = useState(false);
  const pick = () => {
    if (op.trim().length < 2) return toast.error("Scrivi il nome dell'operatore come nel file Vigilpol");
    file.current?.click();
  };
  const upload = (e) => {
    const fl = e.target.files?.[0]; e.target.value = "";
    if (!fl || !window.confirm(`Eliminare dall'archivio tutti i report importati di "${op.trim()}"? L'operazione non si può annullare.`)) return;
    const rd = new FileReader();
    rd.onload = async () => {
      setBusy(true);
      try { const d = await api("/local/vig-reports/import/remove", { method: "POST", body: { data: rd.result, operatore: op.trim() } }); toast.success(`${d.deleted} report di ${op.trim()} eliminati`); setOp(""); }
      catch (err) { toast.error(err.message); } finally { setBusy(false); }
    };
    rd.readAsDataURL(fl);
  };
  return (
    <div className="mt-4 pt-4 border-t flex flex-wrap items-end gap-3" data-testid="vig-import-remove">
      <div className="flex-1 min-w-[220px]">
        <label className="text-xs text-slate-500">Elimina i report importati di un operatore (nome come nel file)</label>
        <Input value={op} onChange={(e) => setOp(e.target.value)} placeholder="es. Rossi Mario" className="h-10 mt-1" data-testid="vig-import-remove-name" />
      </div>
      <Button variant="outline" disabled={busy} onClick={pick} className="rounded-full text-red-700 border-red-200 hover:bg-red-50" data-testid="vig-import-remove-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Trash2 className="w-4 h-4 mr-1" />}Scegli il file ed elimina</Button>
      <input ref={file} type="file" accept=".xlsx" className="hidden" onChange={upload} data-testid="vig-import-remove-file" />
    </div>
  );
}
